

export default function Footer() {
  const scrollToSection = (id: string) => {
    if (id === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-warm-100 text-gray-800 py-16 border-t border-warm-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <button onClick={() => scrollToSection('home')} className="cursor-pointer mb-4 block">
              <img
                src="https://static.readdy.ai/image/7f87cd0470b0952245d57f0e6ea3c4d4/1195916e21ce0a96496e218c7ced9947.png"
                alt="Butler Professional Services"
                className="h-12 w-auto"
              />
            </button>
            <p className="text-sm text-[#612c42] font-semibold mb-2">
              Accounting You Can Trust
            </p>
            <p className="text-sm text-gray-500 leading-relaxed">
              Providing precision accounting and personal service since 1993.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-5 uppercase tracking-wide">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-500 hover:text-[#612c42] transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-500 hover:text-[#612c42] transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-500 hover:text-[#612c42] transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-5 uppercase tracking-wide">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-sm text-[#059669]"></i>
                </div>
                <span className="text-sm text-gray-500 leading-relaxed">
                  2415 San Ramon Valley Blvd, Ste 4229<br />
                  San Ramon, CA 94583
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-sm text-[#059669]"></i>
                </div>
                <a href="tel:5103503216" className="text-sm text-gray-500 hover:text-[#612c42] transition-colors">(510) 350-3216</a>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-sm text-[#059669]"></i>
                </div>
                <span className="text-sm text-gray-500">bps.antonia@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-warm-300 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-gray-400 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Butler Professional Services. All rights reserved.
          </p>
          <a
            href="https://www.brandcraftconsulting.com"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-xs text-gray-400 hover:text-[#612c42] transition-colors"
          >
            Powered by Brand Craft Consulting, LLC
          </a>
        </div>
      </div>
    </footer>
  );
}
